import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDirectoriesScanService } from "services/scanning";
import FileTreeScanModalComponent from "../components/FileTreeScanModalComponent";

const FileTreeScanModal = (props) => {
  const { isOpen, setIsOpen, selectFileCallback, settings } = props;
  const [isFetching, setIsFetching] = useState(false);

  const [treeData, setTreeData] = useState([]);
  const [shouldRenderTree, setShouldRenderTree] = useState(false);

  const [treeMounted, setTreeMounted] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    if (treeData.length) return;
    getFoldersTreeData();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    if (!treeData.length && !isFetching) return;

    if (!treeMounted) {
      const raf = requestAnimationFrame(() => setTreeMounted(true));
      return () => cancelAnimationFrame(raf);
    }
  }, [isOpen, treeData.length, isFetching, treeMounted]);

  const buildTreeFast = (items) => {
    const nodeById = new Map();
    for (const it of items) {
      nodeById.set(it.directoryId, {
        key: it.directoryId,
        title: it.directoryName,
        fullName: it.fullName,
        children: [],
      });
    }

    const roots = [];
    for (const it of items) {
      const node = nodeById.get(it.directoryId);
      const parentId = it.parentId ?? 0;

      const parent = nodeById.get(parentId);

      if (!parent || parentId === 0) {
        roots.push(node);
      } else {
        parent.children.push(node);
      }
    }

    return roots;
  };

  const getFoldersTreeData = async () => {
    setIsFetching(true);
    try {
      const response = await getDirectoriesScanService();
      const treeItems = buildTreeFast(response);
      setTreeData(treeItems);
    } catch (err) {
      console.log(err);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <FileTreeScanModalComponent
      isFetching={isFetching}
      treeMounted={treeMounted}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      settings={settings}
      treeData={treeData}
      selectFileCallback={selectFileCallback}
    />
  );
};

const mapStateToProps = (store) => ({
  settings: store.settingsReducer.settings,
});

export default connect(mapStateToProps)(FileTreeScanModal);
